import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import gsap from 'gsap';

var ListingFiveUpBgImageCardsSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingFiveUpBgImageCardsSlider',
	};

	$.extend(true, this.options, options);

};

ListingFiveUpBgImageCardsSlider.prototype.init = function() {

	var self = this;

	this.currentTimeline = null;

	this.slideEq;

	// sliders
	this.$cardSlider = this.options.$el.find(`.${self.options.baseClass}__cardSlider`);

	// after the slider has initialized, call our svg inline script again
	// so that it can replace svg's in cloned slides
	this.$cardSlider.on('init', function(slick) {
		sitewide.inlineSvgs();

		// create the slide equalizer here, so that it detects clones that are created
		self.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__card, .${self.options.baseClass}__cardMinHeightPlaceholder`) );
		self.slideEq.equalizeHeights();
		
		self.hideCardDetails();
	});

	// after SVG's are replaced, slide height will change so we run the equalizer again
	PubSub.subscribe('Sitewide:inlineSvgs:svgReplaced', function() {
	    self.slideEq.equalizeHeights();
	});

	this.options.$el.on({

		mouseenter: function() {

			// kill the previous timeline in case it's still running
			if (self.currentTimeline) {
				self.currentTimeline.kill();
			}

			var boxShadow = "0px 15px 25px 0px rgba(0,0,0,0.5)";
			if (Breakpoint.value == "xxlarge") {
				boxShadow = "0px 30px 50px 0px rgba(0,0,0,0.5)";
			}
			else if (Breakpoint.value == "large" || Breakpoint.value == "xlarge") {
				boxShadow = "0px 25px 40px 0px rgba(0,0,0,0.5)";
			}

			var $bgImage = $(this).find(`.${self.options.baseClass}__backgroundImage`);
			var $cardContentWrapper = $(this).find(`.${self.options.baseClass}__cardContent`);
			var $textContent = $(this).find(`.${self.options.baseClass}__textContent`);
			var $cardLink = $(this).find(`.${self.options.baseClass}__cardLink`);
			var $cardUnderline = $(this).closest(`.${self.options.baseClass}__cardWrapper`).find(`.${self.options.baseClass}__cardUnderline`);

			gsap.timeline(
				{
					defaults: {
						ease: "power1.out",
					}
				}
			)
			.to($bgImage,
				{
					duration: 0.4,
					scale: 1.1
				},
				"0"
			)
			.to($(this),
				{
					duration: 0.4,
					boxShadow: boxShadow
				},
				"0"
			)
			.to($cardContentWrapper,
				{
					duration: 0.4,
					top: 0
				},
				"0"
			)
			.to($cardUnderline,
				{
					duration: 0.3,
					bottom: -16
				},
				"0"
			)
			.to($textContent,
				{
					duration: 0.4,
					opacity: 1,
					y: 0
				},
				"0.2"
			)
			.to($cardLink,
				{
					duration: 0.4,
					opacity: 1,
					y: 0
				},
				"0.4"
			)
			;

		},

		mouseleave: function() {

			var $bgImage = $(this).find(`.${self.options.baseClass}__backgroundImage`);
			var $cardContentWrapper = $(this).find(`.${self.options.baseClass}__cardContent`);
			var $textContent = $(this).find(`.${self.options.baseClass}__textContent`);
			var $cardLink = $(this).find(`.${self.options.baseClass}__cardLink`);
			var $cardUnderline = $(this).closest(`.${self.options.baseClass}__cardWrapper`).find(`.${self.options.baseClass}__cardUnderline`);

			var cardLowerContentHeight = $(this).find(`.${self.options.baseClass}__lowerContent`).outerHeight();

			gsap.timeline(
				{
					defaults: {
						ease: "power1.out",
					}
				}
			)
			.to($bgImage,
				{
					duration: 0.4,
					scale: 1
				},
				"0"
			)
			.to($(this),
				{
					duration: 0.4,
					boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)"
				},
				"0"
			)
			.to($cardContentWrapper,
				{
					duration: 0.4,
					top: cardLowerContentHeight
				},
				"0"
			)
			.to($textContent,
				{
					duration: 0.4,
					opacity: 0,
					y: 12
				},
				"0"
			)
			.to($cardLink,
				{
					duration: 0.4,
					opacity: 0,
					y: 12
				},
				"0"
			)
			.to($cardUnderline,
				{
					duration: 0.3,
					bottom: 0
				},
				"0"
			)
			// .set($textContent,
			// 	{
			// 		y: 12
			// 	},
			// 	"+=0"
			// )
			// .set($cardLink,
			// 	{
			// 		y: 12
			// 	},
			// 	"+=0"
			// )
			;

		}

	}, `.${self.options.baseClass}__card`);

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		slidesToShow: 5,
		swipeToSlide: true,
		infinite: true,
		centerMode: true,
		centerPadding: '11%',
		
		responsive: [
		
			{
				breakpoint: 2680,
				settings: {
					centerPadding: '7%'
				}
			},
			{
				breakpoint: 2400,
				settings: {
					centerPadding: '3%'
				}
			},
			{
				breakpoint: 2200,
				settings: {
					slidesToShow: 3,
					centerPadding: '20%'
				}
			},
			{
				breakpoint: 1960,
				settings: {
					slidesToShow: 3,
					centerPadding: '14%',
				}
			},
			{
				breakpoint: 1740,
				settings: {
					slidesToShow: 3,
					centerPadding: '11%',
				}
			},
			{
				breakpoint: 1620,
				settings: {
					slidesToShow: 3,
					centerPadding: '8%',
				}
			},
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 3,
					centerPadding: '4%',
				}
			},
			{
				breakpoint: 1340,
				settings: {
					slidesToShow: 2,
					centerPadding: '15%',
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 2,
					centerPadding: '8%',
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					centerPadding: '25%',
				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1,
					centerPadding: '22%',
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 1,
					centerPadding: '18%',
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 1,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					centerPadding: '6%',
				}
			}
			
		]
		

	});

	// rerun equalizer and re-hide card details when window is resized
	PubSub.subscribe("resized", function() {
		// re-initializing the equalizer here fixes a bug where cloned slides weren't getting properly equalized
		self.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__card, .${self.options.baseClass}__cardMinHeightPlaceholder`) );
		self.slideEq.equalizeHeights();

		self.hideCardDetails();
	});

};

ListingFiveUpBgImageCardsSlider.prototype.hideCardDetails = function() {

	var self = this;

	this.options.$el.find('.slick-slide').each(function() {

		var cardLowerContentHeight = $(this).find(`.${self.options.baseClass}__lowerContent`).outerHeight();

		gsap.set($(this).find(`.${self.options.baseClass}__cardContent`),
			{
				top: cardLowerContentHeight
			}
		);

	});

};

export default ListingFiveUpBgImageCardsSlider;
